import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import getConfig from '../../../../config';
import CustomInput from '../../../../generic/CustomInput';
import CustomBtn from '../../../../generic/CustomBtn';
import DropzoneInput from '../../../Dropzone';
import { CustomReactSelect } from '../../../../generic/CustomSelect/CustomSelect';
import { CustomStyles } from '../../../../generic/CustomSelect/CustomeStyles';
import CustomCheckbox from '../../../../generic/CustomCheckbox';
import {
  AGROFORESTRY_TYPE, projectTypes, REFORESTATION_TYPE,
} from '../../../../constans/constans';
import { CoverPhotoInput, CoverPhotoPreview } from './CoverPhoto';
import { ContextForm } from '../../../../utils/projectRegistration';
import Tooltip from '../../../Tooltip';
import { ReactComponent as TooltipIcon } from '../../../../assets/image/carbon/circle-exclamation.svg';
import storage from '../../../../utils/storage';
import './GenInformation.scss';

const { projectDurationType } = getConfig();
const durationOptions = new Array(99).fill('').map((el, index) => ({
  label: index + 1,
  value: index + 1,
}));

const GenInformation = ({ step, nextPage, state, setState, setRequestError, setShowModal }) => {
  const translate = useIntl();
  const { formatMessage } = translate;
  const isInterestData = storage.get('isInterest') || {};
  const { isInterest = false } = isInterestData;
  const { handleSubmit, errors, register, control } = useForm();
  const { formData } = useContext(ContextForm);
  const { projectType } = formData;
  const { projectDuration } = state;
  const [radioButtons, setRadioButtons] = useState(projectTypes(translate, projectType));
  const [filesCid, setFilesCid] = useState({ filesCidDir: '' });
  const [filesList, setFilesList] = useState([]);
  const [showResizedPhoto, setShowResizedPhoto] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [iconCid, setIconCid] = useState({
    iconCidDir: '',
    secondIconCidDir: '',
  });
  const [resizedImage, setResizedImage] = useState({
    largeCoverPhotoBlob: {},
    largeCoverPhotoUrl: '',
    largeCoverLoader: true,
    smallCoverPhotoBlob: {},
    smallCoverPhotoUrl: '',
    smallCoverLoader: true,
  });

  const [reforestationCarbon] = useState([REFORESTATION_TYPE, AGROFORESTRY_TYPE].includes(projectType) && isInterest === true);
  const onRadioChange = (e) => {
    const value = e.target.value;
    const newRadioButtons = [...radioButtons];
    newRadioButtons.forEach((item) => {
      item.checked = item.value === value;
    });
    setRadioButtons(newRadioButtons);
  };

  const onSubmit = (data) => {
    const updData = {
      ...data,
      projectDuration: data.projectDuration?.value.toString(),
    };
    setRequestError(false);
    setShowModal(false);
    setState({
      ...state,
      ...updData,
      ...iconCid,
      ...filesCid,
    });
    nextPage();
  };

  const handleBadIpfs = () => {
    setRequestError(true);
    setShowModal(true);
  };

  if (step !== 0) {
    return null;
  }

  const labelText = `*${formatMessage({
    id: projectDurationType === 'year'
      ? 'wizardForm.step1.expectedProjectDuration'
      : 'wizardForm.step1.expectedProjectDuration-days',
  })}`;

  const defaultValue = projectDuration ? {
    value: projectDuration,
    label: `${projectDuration}`,
  } : null;

  return (
    <div className="generalInformation">
      {showResizedPhoto ? (
        <CoverPhotoPreview
          showResizedPhoto={showResizedPhoto}
          setShowResizedPhoto={setShowResizedPhoto}
          resizedImage={resizedImage}
          setResizedImage={setResizedImage}
          setIconCid={setIconCid}
        />
      ) : null }
      <form onSubmit={handleSubmit(onSubmit)} className="generalInformation__form">
        <FormattedMessage
          id="wizardForm.step1.description"
          values={{
            div: (...chunks) => <div className="generalInformation__description">{chunks}</div>,
            span: (chunks) => <span className="generalInformation__description-text">{chunks}</span>,
            br: <br />,
          }}
        />
        <CustomInput
          type="text"
          label={formatMessage({ id: 'wizardForm.step1.organizationName' })}
          placeholder={formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
          register={register({
            required: formatMessage({ id: 'wizardForm.required' }),
            maxLength: 100,
          })}
          required
          error={errors?.developer}
          value={state.developer}
          name="developer"
          customClass="generalInformation__input"
          customClassLabel="generalInformation__input-label"
        />
        <CustomInput
          type="text"
          label={formatMessage({ id: 'wizardForm.step1.projectName' })}
          placeholder={formatMessage({ id: 'wizardForm.step1.projectName-placeholder' })}
          register={register({
            required: formatMessage({ id: 'wizardForm.required' }),
            maxLength: 100,
          })}
          required
          change={() => { }}
          error={errors?.name}
          value={state.name}
          name="name"
          customClass="generalInformation__input"
          customClassLabel="generalInformation__input-label"
        />
        <CustomReactSelect
          control={control}
          labelText={labelText}
          placeholder={formatMessage({ id: 'wizardForm.step1.expectedProjectDuration-placeholder' })}
          options={durationOptions}
          defaultValue={defaultValue}
          rules={{ required: true }}
          isClearable={false}
          error={errors?.projectDuration}
          name="projectDuration"
          titleClass="generalInformation__input-label"
          wrapperClass="generalInformation__projectDuration"
          selectStyles={CustomStyles(errors)}
        />
        <div className="generalInformation__checkboxes">
          <div className="generalInformation__checkboxes-labelBlock">
            <span className="generalInformation__checkboxes-label">
              *
              {formatMessage({ id: 'wizardForm.step1.projectType' })}
            </span>
            {reforestationCarbon && (
              <Tooltip
                targetClass="generalInformation__checkboxes-tooltip"
                targetElement={(
                  <TooltipIcon
                    data-tip
                    data-iscapture
                    data-for="project-type"
                  />
                )}
                tooltipProps={{
                  id: 'project-type',
                }}
                tooltipElement={(
                  <FormattedMessage
                    id="wizardForm.tooltip.projectType"
                    values={{
                      br: <br />,
                    }}
                  />
                )}
              />
            )}
          </div>
          {errors.type && (
            <span className="generalInformation__warning-text">
              {formatMessage({ id: 'wizardForm.step1.projectType-warning' })}
            </span>
          )}
          {radioButtons.map(({ value, title, description, checked }) => (
            <CustomCheckbox
              type="radio"
              onChange={onRadioChange}
              value={value}
              title={translate.formatMessage({ id: title })}
              description={translate.formatMessage({ id: description })}
              register={register({
                required: true,
              })}
              name="type"
              checked={checked}
              key={value}
              disabled={reforestationCarbon}
            />
          ))}
        </div>
        <div className="generalInformation__coverPhoto">
          <div className="generalInformation__input-label">
            *
            {formatMessage({ id: 'wizardForm.step1.coverPhoto' })}
          </div>
          <div className={errorMsg ? 'generalInformation__infoMsg err' : 'generalInformation__infoMsg'}>
            {formatMessage({ id: 'wizardForm.step1.coverPhoto-warning' })}
          </div>
          <CoverPhotoInput
            showResizedPhoto={showResizedPhoto}
            setShowResizedPhoto={setShowResizedPhoto}
            resizedImage={resizedImage}
            setResizedImage={setResizedImage}
            setErrorMsg={setErrorMsg}
          />
        </div>
        <div className="generalInformation__docsDropzone">
          <div className="generalInformation__input-label">
            {formatMessage({ id: 'wizardForm.step3.projectDocumentation' })}
          </div>
          <div className="wizard__documents-warning customMarginTop">
            <i className="icon-exclamation" />
            <span className="wizard__documents-warning-text">
              {formatMessage({ id: 'wizardForm.step3.projectDocumentation-warning' })}
            </span>
          </div>
          <DropzoneInput
            classCustom=""
            change={setFilesCid}
            multipleFiles
            amountFiles={10}
            droppedFiles={filesList}
            setDroppedFiles={setFilesList}
            previewCustomClass="generalInformation__docsDropzone-fileList"
            handleBadIpfs={handleBadIpfs}
          />
        </div>
        <div className="generalInformation__buttonBlock">
          <CustomBtn
            label={formatMessage({ id: 'button-next' })}
            type
            handleClick={() => { }}
            customClass="btn__next"
          />
        </div>
      </form>
    </div>
  );
};

export default GenInformation;
